export class ScannerSuccessSound {
  private context?: AudioContext;

  async prepare(): Promise<void> {
    try {
      const AudioContextConstructor = window.AudioContext;
      if (!AudioContextConstructor) {
        return;
      }
      this.context ??= new AudioContextConstructor();
      if (this.context.state === 'suspended') {
        await this.context.resume();
      }
    } catch {
      // 音声が利用できない環境でも、スキャン処理自体は継続する。
    }
  }

  play(): void {
    const context = this.context;
    if (!context || context.state !== 'running') {
      return;
    }

    try {
      const startedAt = context.currentTime;
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(880, startedAt);
      gain.gain.setValueAtTime(0.0001, startedAt);
      gain.gain.exponentialRampToValueAtTime(0.12, startedAt + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, startedAt + 0.09);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(startedAt);
      oscillator.stop(startedAt + 0.1);
    } catch {
      // 確認音の失敗で読み取り結果を失わない。
    }
  }

  close(): void {
    void this.context?.close().catch(() => undefined);
    this.context = undefined;
  }
}
